/*@flow*/
import has from 'lib/hasProperty';

export default <T: any>(o: Object, path: string | Array<any>, dv: any): T => {
  let path2;
  if (Array.isArray(path)) {
    path2 = path.join('.');
  } else {
    path2 = path;
  }
  return (
    path2.split('.').reduce((s, k) => (s && has(s, k) ? s[k] : ''), o) || dv
  );
};
